var map = {
	"./2fa.svg": 18791,
	"./EV.svg": 33223,
	"./GpsTracking.svg": 47073,
	"./acceleration.svg": 80866,
	"./active_driver.svg": 39109,
	"./adminstrator.svg": 15396,
	"./aircond.svg": 9930,
	"./all.svg": 8015,
	"./battery.svg": 99885,
	"./body.svg": 23782,
	"./braking.svg": 75422,
	"./breakdown-support.svg": 52805,
	"./building.svg": 58942,
	"./calendar.svg": 26616,
	"./calendarIcon.svg": 18595,
	"./camera.svg": 42447,
	"./car.svg": 36488,
	"./checked.svg": 93573,
	"./checkin.svg": 87360,
	"./checklist-complete.svg": 48774,
	"./checklist.svg": 31102,
	"./checkout.svg": 87958,
	"./clipboard-check.svg": 69043,
	"./cold-chain.svg": 89004,
	"./copy.svg": 57353,
	"./cornering.svg": 2387,
	"./dashboard.svg": 68770,
	"./decrease.svg": 67818,
	"./delete.svg": 69259,
	"./details-fuel.svg": 26421,
	"./details-idling.svg": 72470,
	"./details-ignition.svg": 7228,
	"./details-parking.svg": 29171,
	"./details-pie.svg": 12381,
	"./details-temperature-1.svg": 60735,
	"./details-temperature-2.svg": 81708,
	"./details-vehicle.svg": 8667,
	"./distance.svg": 40439,
	"./document.svg": 38409,
	"./download.svg": 22170,
	"./driver-care-plus-logo.svg": 5497,
	"./driver.svg": 47880,
	"./driving.svg": 58919,
	"./dropdown-history-playback.svg": 35360,
	"./dropdown-live-tracking.svg": 96426,
	"./dropdown-view-profile.svg": 76921,
	"./droplet.svg": 15772,
	"./edit.svg": 84742,
	"./event-calendar.svg": 14853,
	"./event.svg": 35102,
	"./export.svg": 892,
	"./file.svg": 10480,
	"./filter-driving.svg": 36482,
	"./filter-idling.svg": 67114,
	"./filter-offline.svg": 76354,
	"./filter-parking.svg": 83263,
	"./filter.svg": 35920,
	"./fleet-access-settings.svg": 17165,
	"./fuel-management.svg": 10750,
	"./fuel_consumption.svg": 55746,
	"./green-fleet-dashboard.svg": 91331,
	"./hard-drive.svg": 39326,
	"./harsh-braking.svg": 51825,
	"./idling.svg": 32665,
	"./idling_duration.svg": 40036,
	"./ignition.svg": 50527,
	"./increase.svg": 23802,
	"./info.svg": 18370,
	"./insurance.svg": 40270,
	"./language.svg": 4660,
	"./layout.svg": 49552,
	"./license.svg": 9059,
	"./listening.svg": 15517,
	"./lock.svg": 2555,
	"./mapSelector.svg": 61407,
	"./math.svg": 46140,
	"./meter.svg": 62573,
	"./microchip.svg": 65480,
	"./notification.svg": 32759,
	"./open-external.svg": 25866,
	"./other.svg": 13316,
	"./overspeeding.svg": 17995,
	"./p2p.svg": 24048,
	"./playback.svg": 71697,
	"./radio-waves.svg": 86466,
	"./reassign.svg": 3150,
	"./report.svg": 13492,
	"./role_users.svg": 2003,
	"./route.svg": 93629,
	"./routeSide.svg": 60628,
	"./safety.svg": 38916,
	"./satellite.svg": 28821,
	"./search.svg": 50194,
	"./server.svg": 37931,
	"./setting.svg": 66654,
	"./share-off.svg": 16719,
	"./share.svg": 74775,
	"./shield.svg": 14585,
	"./shortcut.svg": 8208,
	"./signal.svg": 90170,
	"./smart-analytic.svg": 58431,
	"./sort-by-time.svg": 73826,
	"./sort.svg": 45906,
	"./speeding.svg": 91173,
	"./speedometer.svg": 11953,
	"./status-driving.svg": 89322,
	"./status-idling.svg": 18034,
	"./status-offline.svg": 3066,
	"./status-parking.svg": 55604,
	"./submenu.svg": 12297,
	"./subsubmenu.svg": 12963,
	"./target.svg": 92693,
	"./toll.svg": 5769,
	"./toll_icon.svg": 57159,
	"./tools.svg": 5443,
	"./total_claim.svg": 74589,
	"./total_number_of_driver.svg": 71013,
	"./total_petrol_claim.svg": 7076,
	"./total_toll_claim.svg": 21001,
	"./traffic-cone.svg": 26355,
	"./trailer.svg": 75935,
	"./transmission_gear_box.svg": 21730,
	"./triangle-exclaimation.svg": 82455,
	"./truck-driver.svg": 77838,
	"./truck.svg": 12259,
	"./two-factor-authentication.svg": 94605,
	"./two-way-arrow.svg": 32762,
	"./upload.svg": 14953,
	"./uploadFile.svg": 94751,
	"./user-setting-complaint.svg": 8796,
	"./user-setting-dashboard.svg": 25619,
	"./user-setting-device-setting.svg": 82484,
	"./user-setting-documentation-user-manual.svg": 6834,
	"./user-setting-documentation.svg": 24297,
	"./user-setting-event-calendar.svg": 70674,
	"./user-setting-fuel-management.svg": 96139,
	"./user-setting-help-center.svg": 18978,
	"./user-setting-profile.svg": 29600,
	"./user-setting-report.svg": 35691,
	"./user-setting-temporary-view.svg": 34756,
	"./user-setting-vehicle.svg": 22351,
	"./user-settings.svg": 1483,
	"./vehicle-icon-bus.svg": 66965,
	"./vehicle-icon-car.svg": 16349,
	"./vehicle-icon-construction.svg": 15170,
	"./vehicle-icon-crane.svg": 67768,
	"./vehicle-icon-mixer.svg": 71644,
	"./vehicle-icon-motor.svg": 63428,
	"./vehicle-icon-truck.svg": 59294,
	"./vehicle-icon-van.svg": 5352,
	"./vehicle.svg": 9398,
	"./video-player.svg": 28103,
	"./view.svg": 6549,
	"./wave-pulse.svg": 37957,
	"./wifi-slash.svg": 42397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90780;